import kendoDefaultMessages from "../../../../../../../../localization/kendo/messages.en-US.json";

export const kendoMessages = kendoDefaultMessages;
